import { render, staticRenderFns } from "./ImportWizard.vue?vue&type=template&id=60bf6402&scoped=true"
import script from "./ImportWizard.vue?vue&type=script&lang=js"
export * from "./ImportWizard.vue?vue&type=script&lang=js"
import style0 from "./ImportWizard.vue?vue&type=style&index=0&id=60bf6402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf6402",
  null
  
)

export default component.exports